export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English", intlLocale: "en-GB" },
  { code: "de", label: "Deutsch", intlLocale: "de-DE" },
  { code: "cs", label: "Čeština", intlLocale: "cs-CZ" },
  { code: "hr", label: "Hrvatski", intlLocale: "hr-HR" },
  { code: "hu", label: "Magyar", intlLocale: "hu-HU" },
  { code: "pl", label: "Polski", intlLocale: "pl-PL" },
  { code: "ro", label: "Română", intlLocale: "ro-RO" },
  { code: "sk", label: "Slovenčina", intlLocale: "sk-SK" },
  { code: "sl", label: "Slovenščina", intlLocale: "sl-SI" },
  { code: "sr", label: "Srpski", intlLocale: "sr-RS" }
];

export function supportedLanguageCodes() {
  return SUPPORTED_LANGUAGES.map(function(language) {
    return language.code;
  });
}

export function normalizeLanguage(code) {
  var normalized = (code || "").toString().trim();
  return supportedLanguageCodes().indexOf(normalized) !== -1 ? normalized : "en";
}

export function intlLocaleForLanguage(code) {
  var normalized = normalizeLanguage(code);
  var language = SUPPORTED_LANGUAGES.find(function(item) {
    return item.code === normalized;
  });
  return language ? language.intlLocale : "en-GB";
}
